// @mui
import { makeStyles } from '@mui/styles';

export const countInputStyle = (theme) => ({
  button: {
    padding: 0,
    color: theme.palette.text.primary
  },

  icon: {
    fontSize: theme.typography.h5.fontSize
  },

  formControlRoot: {
    margin: 0,
    padding: '12px 0px 8px 0px!important',
    maxWidth: '160px!important',
  },

  textFieldRoot: {
    '&::before, &::after': {
      content: 'none'
    }
  },

  textFieldInput: {
    padding: 0,
    minWidth: 35
  }
});

export const useCountInputStyle = makeStyles(countInputStyle);
